import './js/vue'
import './js/import-svgs'

import {initSidebar} from '@/app/js/blocks/sidebar'
import {initSelects} from '@/app/js/blocks/select'
import {initAutoForm} from '@/app/js/blocks/autoForm'
import {initSlider} from '@/app/js/slider'
import {initQuestionsToggler} from '@/app/js/questions-toggle'
import {initSwipers} from '@/app/js/swiper'
import {initProductHeaderShareContainer} from '@/app/js/product-header-share'
import {initAnchorLinks} from '@/app/js/anchor-links'
import {initFilter} from '@/app/js/filter/filter'
import {initCompare} from '@/app/js/compare'
import {handleForms} from '@/app/js/handle-forms'
import {handlePaymentCounters} from '@/app/js/handle-payment-counters'
import {initFancy} from '@/app/js/fancy'
import {handleLinkedContainers} from '@/app/js/linked-container'
import {initInputmask} from '@/app/js/inputmask'
import {handleTargetButtons} from '@/app/js/yandex/target'
import {initAllRanges} from '@/app/js/classes/range'
import {handleRequirePrice} from '@/app/js/require-price'
import {initCookieAgreement} from '@/app/js/cookie-agreement'
import '@/app/js/search/blog-search'
import '@/app/js/mmenu'
import '@/app/js/category-scroller'

initSidebar()
initSelects()
initAutoForm()
initSlider()
initQuestionsToggler()
initSwipers()
initProductHeaderShareContainer()
initAnchorLinks()
initFilter()
initCompare()
initFancy()
initInputmask()
initAllRanges()
initCookieAgreement()

handleForms()
handlePaymentCounters()
handleLinkedContainers()
handleTargetButtons()
handleRequirePrice()
